import React from 'react'
import { connect } from 'react-redux'
import { clearHeader, clearSkip } from 'actions/general'
import ReCAPTCHA from 'react-google-recaptcha'
import { getRecaptchaKey } from 'util/recaptcha'
import RecoverPasswordForm from './form'
import { postPasswordRecovery } from 'actions/password'
import { LoginRoute } from 'resources/routes'
import withRouter from 'hocs/with-router'

function mapStateToProps(state) {
  return {
    result: state.password.getIn(['recoveryReturnData', 'result'], null),
    loading: state.password.get('loading', false),
    submitError: state.password.get('error', false),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    clearHeader: payload => dispatch(clearHeader(payload)),
    clearSkip: payload => dispatch(clearSkip(payload)),
    postPasswordRecovery: payload => dispatch(postPasswordRecovery(payload)),
  }
}

class RecoverPassword extends React.PureComponent {
  componentDidUpdate(prevProps, prevState) {
    if (
      !this.props.submitError &&
      this.props.result === 'success' &&
      !this.state.recaptchaPending
    ) {
      this.props.navigate(LoginRoute)
    }
  }

  componentDidMount() {
    this.props.clearHeader()
    this.props.clearSkip()
  }

  _submit = values => {
    if (this.recaptcha.getValue()) {
      this.recaptcha.reset()
    }
    return new Promise((resolve, reject) => {
      this.setState(
        {
          values: { ...values },
          recaptchaPending: true,
        },
        () => {
          this.resolve = resolve
          this.reject = reject
          if (sessionStorage.getItem('disableRecaptcha') === 'true') {
            this._recaptchaChange('disabledForTesting')
          } else {
            this.recaptcha.execute()
          }
        }
      )
    }).then(() => {
      this.setState({ recaptchaPending: false })
    })
  }

  _recaptchaChange = value => {
    const values = this.state.values
    values.captchaToken = value

    this.props.postPasswordRecovery({
      values,
      resolve: this.resolve,
      reject: this.reject,
    })
  }

  render() {
    return (
      <div className='user'>
        <h1 className='heading--main'>Recover Password</h1>
        <span className='heading--subheading'>
          Enter your email address below and we’ll send you instructions to
          reset your password.
        </span>
        <RecoverPasswordForm
          onSubmit={this._submit}
          loading={this.props.loading}
        />
        <ReCAPTCHA
          ref={recaptcha => {
            this.recaptcha = recaptcha
          }}
          size='invisible'
          sitekey={getRecaptchaKey()}
          onChange={this._recaptchaChange}
        />
      </div>
    )
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RecoverPassword)
)
